<template>
    <div>
        <portal to="buttons">

        </portal>

        <b-card no-body>
            <data-table ref="dataTable" url="/api/orders" :columns="columns" :filter.sync="filter" create="/orders/create" cache-search="tableOrders" sort="OrderId">

                <template #OrderId="data">
                    <b-link :to="data.item.Id" append>{{data.value}}</b-link>
                </template>

                <template #CreateDate="data">
                    <span class="text-nowrap">
                        {{ $moment(data.value).format("DD. MMM YYYY HH:mm") }}
                    </span>
                </template>

                <template #actions="data">
                    <div class="text-nowrap">
                        <b-link :to="{ name: 'order', params: { id: data.item.Id } }">
                            <feather-icon icon="EditIcon" size="16" class="mx-6 my-2" />
                        </b-link>

                        <!--<b-button @click="deleteItem(data.item)" variant="link" class="p-0">
                            <feather-icon icon="TrashIcon" size="16" class="mx-6 my-2" />
                        </b-button>-->
                    </div>
                </template>

            </data-table>
        </b-card>
    </div>
</template>

<script>
    import DataTable from "@/components/DataTable.vue"
    import Toast from '@/components/_toast.vue'

    export default {
        components: {
            DataTable
        },
        data: () => ({
            filter: {},
            columns: [
                //{ key: 'id', label: '#', sortable: true },
                { key: 'OrderId', label: 'Ordrenummer', sortable: true, stickyColumn: false },
                { key: 'CreateDate', label: 'Oprettet', sortable: true },
                { key: 'actions', label: '', class: "text-right" },
            ],
        }),
        computed: {},
        created() { },
        mounted() { },
        methods: {

        },
    }
</script>